import { futureSummary, changedFields, measured } from "./teamAnalysis";

export const editableGoalFields = [
  "total_strength",
  "total_goals",
  "for_total",
  "against_total",
  "for_home",
  "against_home",
  "for_away",
  "against_away",
];
export function goalFieldLabel(field, en = false) {
  const labels = {
    home_for: ["Offensive Heim", "Home attack"],
    home_against: ["Defensive Heim", "Home defence"],
    away_for: ["Offensive Auswärts", "Away attack"],
    away_against: ["Defensive Auswärts", "Away defence"],
    total_strength: ["Spielstärke · Quotient", "Strength · ratio"],
    total_goals: ["Torniveau · Summe pro Spiel", "Goal level · sum per match"],
    for_total: ["Offensive · Gesamt", "Attack · overall"],
    against_total: ["Defensive · Gesamt", "Defence · overall"],
    for_home: ["Offensive Heim", "Home attack"],
    against_home: ["Defensive Heim", "Home defence"],
    for_away: ["Offensive Auswärts", "Away attack"],
    against_away: ["Defensive Auswärts", "Away defence"],
    for_homefactor: ["Offensiver Heimfaktor", "Attacking home factor"],
    against_homefactor: ["Defensiver Heimfaktor", "Defensive home factor"],
    draw_factor: ["Remis-Faktor", "Draw factor"],
  };
  return labels[field]?.[en ? 1 : 0] || field;
}
export function leagueGoalComparison(data, model, field, value) {
  const p = data.result_parameters,
    a = data.league_actual;
  const reference =
    model === "result" &&
    measured(p?.stored_goal_average) &&
    measured(p?.exp_home_factor)
      ? {
          draw_factor: p.drawfactor,
          for_home: (p.stored_goal_average * p.exp_home_factor) / 2,
          against_home: (p.stored_goal_average * (2 - p.exp_home_factor)) / 2,
          for_away: (p.stored_goal_average * (2 - p.exp_home_factor)) / 2,
          against_away: (p.stored_goal_average * p.exp_home_factor) / 2,
        }
      : model === "statistics" && data.ranking?.length
      ? Object.fromEntries(
          ["for_home", "against_home", "for_away", "against_away"].map((k) => [
            k,
            data.ranking.every((r) => measured(r[k]))
              ? data.ranking.reduce((s, r) => s + r[k], 0) / data.ranking.length
              : null,
          ])
        )
      : null;
  const stored = futureSummary(reference)?.[field] ?? null;
  const actual =
    a?.games > 0 && measured(a.home) && measured(a.away)
      ? futureSummary({
          for_home: a.home / a.games,
          against_home: a.away / a.games,
          for_away: a.away / a.games,
          against_away: a.home / a.games,
        })?.[field] ?? null
      : null;
  const diff = measured(value) && measured(stored) ? value - stored : null;
  return {
    stored,
    actual,
    diff,
    percent: stored > 0 && measured(diff) ? (100 * diff) / stored : null,
    favorable:
      measured(diff) && diff !== 0
        ? field.startsWith("against")
          ? diff < 0
          : diff > 0
        : null,
  };
}
export function settingChanges(data, draft, stat) {
  const rows = [];
  for (const [id, row] of Object.entries(draft || {})) {
    for (const c of changedFields(data.result_teams?.[id], row))
      if (!["rank", "team_id", "total_goals"].includes(c.field))
        rows.push({ id, model: "result", group: "", ...c });
  }
  for (const [id, team] of Object.entries(stat?.teams || {})) {
    for (const group of [...Object.keys(team.statistics || {}), "conversion"]) {
      const before =
        group === "conversion"
          ? data.state?.teams?.[id]?.conversion
          : data.state?.teams?.[id]?.statistics?.[group];
      const after =
        group === "conversion" ? team.conversion : team.statistics[group];
      for (const c of changedFields(before, after))
        rows.push({ id, model: "statistics", group, ...c });
    }
  }
  return rows;
}
